export default "POST_MESSAGE_MODULE";
